import { useNavigate } from "react-router-dom";
import { ADMIN_PROTECTED_ROUTES } from "../../routes";

export const handleViewDetails = (id: string) => {
  const navigate = useNavigate();
  navigate(ADMIN_PROTECTED_ROUTES.TENANT_DETAILS.replace(":id", id));
};
